import React, { useEffect, useMemo, useRef, useReducer, useState } from 'react';
import packageJson from '../../../../package.json'
export const Bienvenido = () => {
    const version = packageJson.version


    return (
        <>
            <div className='w-full h-full flex flex-col gap-2 justify-center items-center opacity-30'>
                <img src='https://indexnetperu.com/img/gestionincidencias/incidencia2.jpg' alt='' className='lg:w-[200px]'></img>
                <span>V. {version}</span>
            </div>
        </>
    )
}